import { RefObject, useEffect } from "react";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { POINT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION } from "@/common/sse-api-event-source-message-types";
import { useMutateExplorerItems } from "@/state/jotai/hooks/useMutateExplorerItems.ts";
import { emitEvent } from "@/services/event-emitter.ts";
import { EventTypes, NotificationType, NotificationTypes } from "@/types/types.ts";

function usePointConversationUserMentionedShowNotification(eventSourceRef: RefObject<EventSource | null>) {
  const { appendItem } = useMutateExplorerItems();

  // POINT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handle = (e: MessageEvent) => {
      const {
        tabId,
        notification,
        explorerItem,
      } = JSON.parse(e.data);

      appendItem(explorerItem)

      emitEvent(EventTypes.POINT_USER_MENTION_ADD_NOTIFICATION, {
        ...notification,
        uniqueTabId: tabId,
        type: NotificationTypes.USER_POINT_MENTION_NOTIFICATION,
      } as NotificationType)
    }
    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      POINT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION,
      handle,
    );

    // Cleanup
    return () => {
      removeListener();
    };
  }, [
    appendItem,
    eventSourceRef,
  ]);
}

export default usePointConversationUserMentionedShowNotification;
